import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "articleBox" }
const _hoisted_2 = { class: "articleMain" }
const _hoisted_3 = { class: "articleDate" }
const _hoisted_4 = { class: "botLeft botLeft1" }
const _hoisted_5 = {
  key: 1,
  class: "botM"
}
const _hoisted_6 = { class: "botLeft botRight" }
const _hoisted_7 = {
  key: 1,
  class: "botM"
}
const _hoisted_8 = {
  key: 0,
  class: "successPart"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_head_search = _resolveComponent("head-search")!
  const _component_md_editor = _resolveComponent("md-editor")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_head_search, {
        currentPath: _ctx.articleData.path,
        ref: "headPart",
        onRefreshArticle: _ctx.getTreeData,
        onGetArticleMes: _ctx.getArticleMes,
        style: {"position":"fixed","top":"0","left":"0","z-index":"99998","right":"0","background":"#fff"}
      }, null, 8, ["currentPath", "onRefreshArticle", "onGetArticleMes"]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_md_editor, {
          class: "isMd",
          toolbarsExclude: "[ 'mermaid', 'katex', 'github']",
          toolbars: _ctx.toolbars,
          modelValue: _ctx.articleData.docContent,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.articleData.docContent) = $event)),
          onOnHtmlChanged: _ctx.saveHtml,
          preview: true,
          previewOnly: true,
          noPrettier: true,
          showCodeRowNumber: true
        }, null, 8, ["toolbars", "modelValue", "onOnHtmlChanged"])
      ]),
      _createElementVNode("div", _hoisted_3, " 更新日期：" + _toDisplayString(_ctx.articleData.updateTime), 1),
      _createElementVNode("div", {
        class: "articleBot",
        style: _normalizeStyle({'border-bottom':_ctx.articleData.pre>=0&&_ctx.articleData.post>=0?'1px solid #E0E6EF':'none'})
      }, [
        _createElementVNode("div", _hoisted_4, [
          (_ctx.articleData.pre!='-1'&&_ctx.articleData.pre!='')
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "botT",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeArticle('pre')))
              }, "上一篇"))
            : _createCommentVNode("", true),
          (_ctx.articleData.pre!='-1')
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.articleData.preName), 1))
            : _createCommentVNode("", true)
        ]),
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "articleBorder" }, null, -1)),
        _createElementVNode("div", _hoisted_6, [
          (_ctx.articleData.post!='-1'&&_ctx.articleData.post!='')
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "botT",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeArticle('next')))
              }, "下一篇"))
            : _createCommentVNode("", true),
          (_ctx.articleData.post!='-1')
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.articleData.postName), 1))
            : _createCommentVNode("", true)
        ])
      ], 4)
    ]),
    (_ctx.showSuccessPart)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8))
      : _createCommentVNode("", true)
  ], 64))
}